<script lang="ts">
	import faqImage2xl from "@assets/images/fathers-family-club-faq.jpg?webp&imagetools";
	import faqImageXs from "@assets/images/fathers-family-club-faq.jpg?webp&w=640&imagetools";
	import faqImageLg from "@assets/images/fathers-family-club-faq.jpg?webp&w=960&imagetools";
	import Media from "@components/common/Media.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import translations from "./GiftSubscriptionFaqSection.translations.json" with { type: "json" };
	import SubscriptionFaqSection from "./SubscriptionFaqSection.svelte";

	const translate = getTranslate(translations);

	const faqs = [
		{ question: translate("faq1Question"), answer: translate("faq1Answer") },
		{ question: translate("faq2Question"), answer: translate("faq2Answer") },
		{ question: translate("faq3Question"), answer: translate("faq3Answer") },
		{ question: translate("faq4Question"), answer: translate("faq4Answer") },
		{ question: translate("faq5Question"), answer: translate("faq5Answer") },
		{ question: translate("faq6Question"), answer: translate("faq6Answer") },
	];
</script>

<SubscriptionFaqSection title={translate("faqTitle")} {faqs} group="gift-subscription-faq">
	{#snippet media()}
		<Media
			source={{ type: "image/webp", src: faqImageXs }}
			sourcesets={{ ">lg": faqImageLg, ">2xl": faqImage2xl }}
			width={640}
			height={427}
			alt=""
		/>
	{/snippet}
</SubscriptionFaqSection>
